import { ReactElement, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import Icon from '@mui/material/Icon';
import { ExpandMoreRounded, ExpandLessRounded } from '@mui/icons-material';

// Components
import Button from 'components/Button/Button';

// Styles
import styles from './contextualmenu.module.scss';

export interface IContextualMenuOptionProps {
  name: string;
  onSelectAction?(): void;
  icon?: string;
  selected?: boolean;
}

export interface IContextualMenuProps {
  label?: string;
  options?: IContextualMenuOptionProps[];
}

export const ContextualMenu = (props: IContextualMenuProps): ReactElement => {
  const { label, options } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const node = useRef(null);

  const handleClickOutside = (e) => {
    // @ts-ignore: ref type
    if (!node?.current?.contains(e.target)) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mouseDown', handleClickOutside);
  }, []);

  return (
    <div ref={node} className={styles['contextual-dropdown']}>
      <div className={styles['contextual-dropdown-selection']}>
        <span className={styles['contextual-label']}>{label}</span>
        <Button onClick={(): void => setMenuOpen(!menuOpen)}>
          {options?.find((o: IContextualMenuOptionProps): boolean => o.selected)?.name}
          {menuOpen ? <ExpandLessRounded /> : <ExpandMoreRounded />}
        </Button>
      </div>
      <div className={classNames(styles['contextual-dropdown-menu'], { [styles.active]: menuOpen })}>
        <ul>
          {options?.map((option: IContextualMenuOptionProps, idx: number): ReactElement => {
            const { icon, name, onSelectAction, selected } = option;
            return (
              <li
                key={idx}
                className={classNames(styles['menu-item'], { [styles.selected]: selected })}
                onClick={(): void => {
                  onSelectAction?.();
                  setMenuOpen(false);
                }}
              >
                {icon && <Icon>{icon}</Icon>}
                {name}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
